import React, { ReactNode } from 'react';

export const HeaderTemplate = ({
  children,
}: {
  children: ReactNode[] | ReactNode;
}): JSX.Element => <>{children}</>;
